import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { MarkedDirective } from 'src/app/directives/marked.directive';
import { CommunityPolicyService } from 'src/app/services/community-policy.service';

@Component({
    imports: [MarkedDirective],
    selector: 'rdx-community-policy',
    standalone: true,
    styleUrls: ['./community-policy.component.scss'],
    templateUrl: './community-policy.component.html',
})
export class CommunityPolicyComponent implements OnDestroy, OnInit {
    communityPolicyText: string;
    private isDestroyed = false;

    constructor(private communityPolicyService: CommunityPolicyService) {}

    ngOnInit() {
        this.communityPolicyService
            .getPolicy()
            .pipe(takeWhile(() => !this.isDestroyed))
            .subscribe((policy) => {
                this.communityPolicyText = policy.text;
            });
    }

    ngOnDestroy() {
        this.isDestroyed = true;
    }
}
